// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAOAPXeGks8HiA7TjgBkbgmVpNE6pqj8Mg",
    authDomain: "gdr-jweller-s.firebaseapp.com",
    projectId: "gdr-jweller-s",
    storageBucket: "gdr-jweller-s.firebasestorage.app",
    messagingSenderId: "451533223861",
    appId: "1:451533223861:web:383f44e92858949eea4bfc",
    measurementId: "G-SNMBTJM2N4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };